import React from 'react';
import { ProviderCard } from './ProviderCard';
import { useAuth } from '@/contexts/AuthContext';

/** Emails para os quais o provider 'gateway-whatsapp' (WhatsApp QR Code) fica oculto */
const HIDE_GATEWAY_WHATSAPP_EMAILS = ['henrique@trojahn.com.br'];

/**
 * Grid of available providers for selection
 *
 * @example
 * <ProviderGrid
 *   selectedProvider={selectedProvider}
 *   onProviderSelect={(id) => setSelectedProvider(id)}
 * />
 */
export interface ProviderGridProps {
  /** Currently selected provider ID */
  selectedProvider: string | null;
  /** Callback when a provider is selected */
  onProviderSelect: (providerId: string) => void;
}

interface ProviderOption {
  id: string;
  name: string;
  description: string;
}

const availableProviders: ProviderOption[] = [
  {
    id: 'gateway-whatsapp',  // ✅ Correto conforme ProviderRegistry
    name: 'WhatsApp (QR Code)',
    description: 'Conecte usando QR Code - ideal para números pessoais',
  },
  {
    id: 'whatsapp-business',
    name: 'WhatsApp Business API',
    description: 'Conecte usando WhatsApp Business API oficial',
  },
  {
    id: 'instagram-messaging',
    name: 'Instagram Direct',
    description: 'Conecte sua conta do Instagram para mensagens diretas',
  },
  {
    id: 'facebook-messenger',
    name: 'Facebook Messenger',
    description: 'Conecte sua página do Facebook para atendimento',
  },
  {
    id: 'telegram-bot',
    name: 'Telegram Bot',
    description: 'Crie um bot do Telegram para atendimento automatizado',
  },
  {
    id: 'email-smtp',
    name: 'E-mail (SMTP)',
    description: 'Conecte uma conta de e-mail via SMTP',
  },
  {
    id: 'email-resend',
    name: 'E-mail nativo',
    description: 'Envie e receba e-mails com domínio próprio',
  },
  {
    id: 'website-widget',
    name: 'Widget de Chat',
    description: 'Widget embedável para seu site - atendimento em tempo real',
  },
];

export const ProviderGrid: React.FC<ProviderGridProps> = ({
  selectedProvider,
  onProviderSelect,
}) => {
  const { state } = useAuth();
  const userEmail = state.user?.email;

  const visibleProviders = availableProviders.filter((provider) => {
    if (
      provider.id === 'gateway-whatsapp' &&
      userEmail &&
      HIDE_GATEWAY_WHATSAPP_EMAILS.includes(userEmail)
    ) {
      return false;
    }
    return true;
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {visibleProviders.map((provider) => (
        <ProviderCard
          key={provider.id}
          providerId={provider.id}
          name={provider.name}
          description={provider.description}
          selected={selectedProvider === provider.id}
          onClick={() => onProviderSelect(provider.id)}
        />
      ))}
    </div>
  );
};

ProviderGrid.displayName = 'ProviderGrid';
